import PageData from "../../common/ts/PageData";
import {SwipeComponent} from "../../common/ts/components/core/SwipeComponent";

export default class HipflatSimilarListings {
    private readonly pageData: PageData;
    private readonly similarListingsSectionClass = '.js-wl-similar-listings';
    private readonly similarListingsSection: HTMLElement;

    constructor(pageData: PageData) {
        this.similarListingsSection = document.querySelectorAll(this.similarListingsSectionClass)[0] as HTMLElement;
        this.pageData = pageData;
        this.whenUserReachSection(this.getContent(this.updateSection()))
    }

    static init(pageData: PageData) {
        return new HipflatSimilarListings(pageData)
    }

    private updateSection() {
        return (similarListingsHtml: string) => {
            this.updateSimilarListingsSectionWith(similarListingsHtml);
            this.reloadSectionSwiper();
        };
    }

    private whenUserReachSection(callback: () => Promise<void>) {
        const similarListingsObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    void callback()
                }
            });
        }, {});
        const similarListingsContainers = document.querySelectorAll('.js-wl-similar-listings');
        similarListingsContainers.forEach((element) => {
            similarListingsObserver.observe(element);
        });
    }

    public getContent(callback: (html: string) => void) {
        return async () => await this.fetchSimilarListingsContent(this.pageData)
            .then(callback);
    };

    private async fetchSimilarListingsContent(pageData: PageData) {
        const request = await fetch(`/hipflat/similarListings/${pageData.proppitId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                ...this.addLocaleHeader(),
            },
            body: JSON.stringify({
                pageViewId: pageData.pageViewId,
            }),
        });
        return request.text();
    }

    private updateSimilarListingsSectionWith(html: string) {
        const titleElement = this.similarListingsSection.getElementsByClassName('js-wl-similar-listings__title')[0]!;
        const toSerpButtonElement = this.similarListingsSection.getElementsByClassName('js-wl-similar-listings__to-serp-button')[0]!;
        if (html.length > 0) {
            titleElement.classList.remove('hidden');
            toSerpButtonElement.classList.remove('hidden');
        }
        const snippetsContainer = this.similarListingsSection.getElementsByClassName('js-wl-similar-listings__snippets')[0]!;
        snippetsContainer.insertAdjacentHTML('beforeend', html);
    }

    private reloadSectionSwiper() {
        const swiperContainer = this.similarListingsSection.getElementsByClassName(`${SwipeComponent.getSwiperContainerSelector()}`)[0];
        const scrollAmount: number = parseInt(swiperContainer.getAttribute(SwipeComponent.getSwiperScrollAmountSelector()) || '0');
        SwipeComponent.init(swiperContainer, scrollAmount);
    }

    private addLocaleHeader(): HeadersInit {
        const meta = document.querySelector('meta[name="wl-locale"]');
        if (!meta) return {};
        return {
            'wl-locale': meta.getAttribute('content') || '',
        }
    }
}
